'use client'

import styled from 'styled-components'

import LoadingDecidechile from '@/app/components/LoadingDecidechile'

type WorkingPageProps = {
  className?: string
}

const WorkingPage = ({ className }: WorkingPageProps) => {
  return (
    <Wrapper className={className}>
      <LoadingDecidechile />
      Pronto estaremos disponibles.
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
export default WorkingPage
